import axios from "axios";
import { API_URL, getAuthHeader } from ".";
import { ResponseModel } from "../Models/ResponseModel";
import { Asset } from "../Models/Asset";
import { AssetQuantity } from "../Models/AssetQuantity";

class AssetApi {
  static getAsset(id: number) {
    return axios.get<Asset>(`${API_URL}/api/asset/${id}`, getAuthHeader());
  }
  static getAssetList() {
    return axios.get<Asset[]>(`${API_URL}/api/asset/list`, getAuthHeader());
  }
  static addUpdateAsset(request: Asset) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/asset`,
      request,
      getAuthHeader()
    );
  }
  static deleteAsset(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/asset/${id}`,
      getAuthHeader()
    );
  }
  static getAssetQuantitiesByAssetId(id: number) {
    return axios.get<AssetQuantity[]>(
      `${API_URL}/api/asset/${id}/quantity/list`,
      getAuthHeader()
    );
  }
  static updateAssetQuantities(id: number, deliveryId: number) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/asset/${id}/delivery/${deliveryId}`,
      null, // no body
      getAuthHeader()
    );
  }
}

export default AssetApi;
